<template>
  <div>
    <span v-if="mini">
      <v-avatar size="40">
        <img
          :src="user.organisation_settings.logo_url"
        >
      </v-avatar>
    </span>
    <v-select
      v-else
      v-model="selectedTeam"
      :items="selectTeamItems"
      :loading="loading "
      return-object
      item-value="id"
      item-text="name"
      :label="$t('table_headers.admin_staff.teams')"
      background-color="white"
      solo
      dense
      outlined
      hide-details
      style="width: 300px"
    >
      <template v-slot:selection="{item}">
        <v-avatar size="30">
          <img
            :src="user.organisation_settings.logo_url"
          >
        </v-avatar>
        <span
          class="ml-2 font-weight-bold"
          style="max-width: 160px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
        >{{ item.short_name }}</span>
      </template>
      <template v-slot:item="{item}">
        <v-avatar size="30">
          <img
            :src="user.organisation_settings.logo_url"
          >
        </v-avatar>
        <span
          class="ml-2"
          style="max-width: 160px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
        >{{ item.short_name }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>

export default {
  name: 'TeamSelectMenu',
  props: {
    allTeams: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedTeam: {
      get: function() {
        return this.$store.getters[this.$storeGetters.APP_CURRENT_TEAM]
      },
      set: function(val) {
        if (this.$route.name === this.$routeNames.ADMIN_PLAYER_EDIT) {
          this.$router.push({ name: this.$routeNames.ADMIN_PLAYERS })
        } else if (this.$route.name === this.$routeNames.PLAYER_DETAILS) {
          this.$router.go(-1)
        }
        this.$store.dispatch(this.$storeActions.APP_SET_CURRENT_TEAM, val)
      }
    },
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    loading() {
      return this.$store.getters[this.$storeGetters.APP_LOADING]
    },
    teams() {
      return this.$store.getters[this.$storeGetters.APP_TEAMS]
    },
    hasAllTeamsOption() {
      return this.allTeams
    },
    selectTeamItems() {
      if (!this.teams) return
      const selectTeamItems = []

      if (this.hasAllTeamsOption) {
        selectTeamItems.push({ id: 'all', name: this.$t('dropdown.team_selection.all_teams') })
        selectTeamItems.push({ divider: true })
      }

      selectTeamItems.push(...this.teams)

      return selectTeamItems
    }
  },
  created() {
    // this.selectedTeam = this.selectItems[0]
  }
}
</script>
